






import { useState } from "react";
import { motion } from "framer-motion";
import { getTotalDonation } from "../api/apiServices";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { Heart, Calendar } from "lucide-react";

export default function TotalDonationPage() {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch = async () => {
    setLoading(true);
    try {
      const res = await getTotalDonation({ from, to });
      setData(res);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const images = [
    "https://images.pexels.com/photos/6646926/pexels-photo-6646926.jpeg",
    "https://images.pexels.com/photos/6646901/pexels-photo-6646901.jpeg",
    "https://images.pexels.com/photos/8061641/pexels-photo-8061641.jpeg",
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="space-y-8"
    >
      {/* Hero Slider */}
      {/* Hero Slider */}
<Swiper
  modules={[Pagination, Autoplay]}
  pagination={{ clickable: true }}
  autoplay={{ delay: 3000 }}
  loop
  className="rounded-xl mt-4 max-w-[1400px] overflow-hidden shadow-lg"
>
  {images.map((img, i) => (
    <SwiperSlide key={i}>
      <div className="relative w-full h-64 md:h-[420px]">
        <img
          src={img}
          alt={`slide-${i}`}
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
          <div className="text-center text-white px-6">
            <h2 className="text-2xl md:text-4xl font-bold mb-2">
              Empower Change
            </h2>
            <p className="text-sm md:text-lg">
              Together we can make a difference with every donation.
            </p>
          </div>
        </div>
      </div>
    </SwiperSlide>
  ))}
</Swiper>


      {/* Filters */}
      <div className="bg-white p-6 rounded-lg shadow space-y-4">
        <h2 className="text-2xl text-black font-bold flex items-center gap-2">
          <Heart className="text-orange-500" /> Total Donation
        </h2>
        <div className="flex flex-col md:flex-row gap-3">
          <div className="flex items-center gap-2 border p-2 rounded w-full md:w-auto">
            <Calendar className="w-4 h-4 text-gray-200" />
            <input
              type="date"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              className="outline-none flex-1"
            />
          </div>
          <div className="flex items-center gap-2 border p-2 rounded w-full md:w-auto">
            <Calendar className="w-4 h-4 text-gray-500" />
            <input
              type="date"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              className="outline-none flex-1"
            />
          </div>
          <button
            onClick={fetch}
            disabled={loading}
            className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition disabled:opacity-50"
          >
            {loading ? "Loading..." : "Fetch"}
          </button>
        </div>
      </div>

      {/* Results */}
      <div className="bg-white p-6 rounded-lg shadow text-center">
        {!data ? (
          <p className="text-gray-500">No data yet. Select a date range.</p>
        ) : (
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <h3 className="text-xl font-semibold text-gray-700 mb-2">
              Donation Summary
            </h3>
            <p className="text-4xl font-bold text-orange-600">
              ${new Intl.NumberFormat().format(data.totalAmount || 0)}
            </p>
            <p className="text-gray-500 mt-1">
              From {from || "Start"} to {to || "Today"}
            </p>
          </motion.div>
        )}
      </div>
    </motion.div>
  );
}
